import React from 'react'
import FundingContainer from './FundingContainer'

const Funding = () => <FundingContainer data-test="component-funding" />

export default Funding
